import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { UserRegistrationThankyouPage } from 'src/app/model/page/group/user/user-registration-thankyou-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-user-registration-thankyou-page',
  templateUrl: './user-registration-thankyou-page.component.html',
  styleUrls: ['./user-registration-thankyou-page.component.scss']
})
export class UserRegistrationThankyouPageComponent implements OnInit {
  UserRegistrationThankyouPage: UserRegistrationThankyouPage = {} as UserRegistrationThankyouPage;
  preferred_userName: any = '';

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    const query = { 'fields.title': 'User Registration Thank You' };
    this.contentfulService.getPageContentWithEntries(query).then((userRegistrationThankyouEntries) => {
      this.mapBanner(userRegistrationThankyouEntries);
    });
    this.preferred_userName = localStorage.getItem('preferred_userName');
  }
  private mapBanner(confirmedEmailPageEntries: Entry<any>[]) {
    confirmedEmailPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }
  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.UserRegistrationThankyouPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }
  ngAfterViewChecked(): void {
    localStorage.removeItem('redirect_url');
  }
}
